import { isValid, format as orgFormat, formatISO as orgFormatISO, parse as orgParse, parseISO as orgParseISO } from 'date-fns';

export * from 'date-fns';

// intercept empty values to prevent date-fns from throwing an error
function format(date, formatString, options) {
    if (!date || !isValid(date)) {
        return '';
    }
    return orgFormat(date, formatString, options);
}

function formatISO(date, options) {
    if (!date || !isValid(date)) {
        return '';
    }
    return orgFormatISO(date, options);
}

function parse(dateString, formatString, referenceDate, options) {
    if (!dateString) {
        return null;
    }
    return orgParse(dateString, formatString, referenceDate, options);
}

function parseISO(dateString, options) {
    if (!dateString) {
        return null;
    }
    return orgParseISO(dateString, options);
}

export { format, formatISO, parse, parseISO };
